import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=3d0dc566&scoped=true&"
import script from "./horizontal.vue?vue&type=script&lang=js&"
export * from "./horizontal.vue?vue&type=script&lang=js&"
import style0 from "./horizontal.vue?vue&type=style&index=0&id=3d0dc566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0dc566",
  null
  
)

export default component.exports